import { ReactComponent as EricssonSvg } from './Ericsson.svg';


const Ericsson = () => (
    <div className="companyName">
       <EricssonSvg/>
    </div>
)

export default Ericsson;
